export const AlterNameCell = ({ value }: { value: any }) => {
    return <span>{value || ""}</span>
}
